<template>
  <div class="wave-divider" :class="{ 'wave-flip': flip }">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1440 70"
      width="100%"
      preserveAspectRatio="none"
      :class="fillClass"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M0,35 C360,70 1080,0 1440,35 L1440,70 L0,70 Z" />
    </svg>
  </div>
</template>

<script setup>
/* global defineProps */

defineProps({
  flip: { type: Boolean, default: false },
  fillClass: { type: String, default: '' }
})
</script>

<style scoped>
.wave-divider {
  display: block;
  line-height: 0;
  overflow: hidden;
  width: 100%;
}

.wave-divider svg {
  display: block;
  width: 100%;
  height: auto;
}

.wave-flip svg {
  transform: scaleY(-1);
  transform-origin: center;
}
</style>
